import type { LobbyCategoryId } from "./types";

/** Display-only transcription. These values never configure or calculate member rewards. */
export type ReferenceRebateProvider = {
  name: string;
  tiers: readonly { tier: string | null; turnoverTotal: number | null; ratePercent: number }[];
};

export const referenceRebateSource = {
  url: "http://teosdf.com/personal-center/gameManage",
  label: "teosdf.com 游戏管理",
  checkedAt: "2026-09-14",
} as const;

/** Lottery play rates are specific to this named lottery and market, not turnover tiers. */
export const referenceLotteryRebateRates = {
  lotteryName: "香港六合彩",
  marketName: "盘口A",
  plays: [
    { playType: "特码", ratePercent: 0 },
    { playType: "两面", ratePercent: 2.8 },
    { playType: "特码头数", ratePercent: 4.8 },
    { playType: "特码尾数", ratePercent: 2.8 },
    { playType: "特码五行", ratePercent: 1.3 },
    { playType: "特码合肖", ratePercent: 2.8 },
    { playType: "特肖", ratePercent: 3.3 },
    { playType: "色波", ratePercent: 2.8 },
    { playType: "半波", ratePercent: 2.8 },
    { playType: "正码", ratePercent: 10 },
    { playType: "正码特", ratePercent: 2.8 },
    { playType: "二全中", ratePercent: 15 },
    { playType: "三中二", ratePercent: 15 },
    { playType: "三全中", ratePercent: 15 },
    { playType: "一肖", ratePercent: 1.3 },
    { playType: "二连肖", ratePercent: 0.8 },
    { playType: "三连肖", ratePercent: 0.8 },
    { playType: "四连肖", ratePercent: 0.8 },
    { playType: "五连肖", ratePercent: 0.8 },
    { playType: "二连尾", ratePercent: 0.8 },
    { playType: "三连尾", ratePercent: 0.8 },
    { playType: "四连尾", ratePercent: 0.8 },
    { playType: "五连尾", ratePercent: 0 },
    { playType: "总肖", ratePercent: 1.3 },
    { playType: "一尾", ratePercent: 2.8 },
    { playType: "自选5不中", ratePercent: 1.8 },
    { playType: "自选6不中", ratePercent: 1.8 },
    { playType: "自选7不中", ratePercent: 1.8 },
    { playType: "自选8不中", ratePercent: 1.8 },
    { playType: "自选9不中", ratePercent: 1.8 },
    { playType: "自选10不中", ratePercent: 1.8 },
  ],
} as const;

// null preserves a literal dash in the source; it does not mean zero or no threshold.
export const referenceRebateRates: Readonly<Record<LobbyCategoryId, readonly ReferenceRebateProvider[]>> = {
  "slots": [
    {
      "name": "PG电子",
      "tiers": [
        {
          "tier": "A",
          "turnoverTotal": 50000,
          "ratePercent": 0.9
        },
        {
          "tier": "B",
          "turnoverTotal": 200000,
          "ratePercent": 1.0
        },
        {
          "tier": "C",
          "turnoverTotal": 500000,
          "ratePercent": 1.1
        },
        {
          "tier": "D",
          "turnoverTotal": 1000000,
          "ratePercent": 1.2
        },
        {
          "tier": "E",
          "turnoverTotal": 3000000,
          "ratePercent": 1.3
        },
        {
          "tier": "F",
          "turnoverTotal": 5000000,
          "ratePercent": 1.4
        }
      ]
    },
    {
      "name": "Pragmatic Play",
      "tiers": [
        {
          "tier": "A",
          "turnoverTotal": 50000,
          "ratePercent": 0.9
        },
        {
          "tier": "B",
          "turnoverTotal": 200000,
          "ratePercent": 1.0
        },
        {
          "tier": "C",
          "turnoverTotal": 500000,
          "ratePercent": 1.1
        },
        {
          "tier": "D",
          "turnoverTotal": 1000000,
          "ratePercent": 1.2
        },
        {
          "tier": "E",
          "turnoverTotal": 2000000,
          "ratePercent": 1.3
        },
        {
          "tier": "F",
          "turnoverTotal": 5000000,
          "ratePercent": 1.4
        }
      ]
    },
    {
      "name": "123Go电子",
      "tiers": [
        {
          "tier": "A",
          "turnoverTotal": 50000,
          "ratePercent": 0.9
        },
        {
          "tier": "B",
          "turnoverTotal": 200000,
          "ratePercent": 1.0
        },
        {
          "tier": "C",
          "turnoverTotal": 500000,
          "ratePercent": 1.1
        },
        {
          "tier": "D",
          "turnoverTotal": 1000000,
          "ratePercent": 1.2
        },
        {
          "tier": "E",
          "turnoverTotal": 3000000,
          "ratePercent": 1.3
        },
        {
          "tier": "F",
          "turnoverTotal": 5000000,
          "ratePercent": 1.4
        }
      ]
    }
  ],
  "live": [
    {
      "name": "景鹤视讯",
      "tiers": [
        {
          "tier": "A",
          "turnoverTotal": 50000,
          "ratePercent": 1.0
        },
        {
          "tier": "B",
          "turnoverTotal": 100000,
          "ratePercent": 1.2
        },
        {
          "tier": "C",
          "turnoverTotal": 1000000,
          "ratePercent": 1.4
        },
        {
          "tier": "D",
          "turnoverTotal": 3000000,
          "ratePercent": 1.6
        },
        {
          "tier": "E",
          "turnoverTotal": 5000000,
          "ratePercent": 1.8
        },
        {
          "tier": "F",
          "turnoverTotal": 50000000,
          "ratePercent": 1.8
        }
      ]
    }
  ],
  "board": [
    {
      "name": "SQP棋牌",
      "tiers": [
        {
          "tier": "A",
          "turnoverTotal": 100,
          "ratePercent": 0.0
        },
        {
          "tier": "B",
          "turnoverTotal": 200,
          "ratePercent": 0.0
        },
        {
          "tier": "C",
          "turnoverTotal": 300,
          "ratePercent": 0.0
        },
        {
          "tier": "D",
          "turnoverTotal": 500,
          "ratePercent": 0.0
        },
        {
          "tier": "E",
          "turnoverTotal": 1000,
          "ratePercent": 0.0
        },
        {
          "tier": "F",
          "turnoverTotal": 2000,
          "ratePercent": 0.0
        }
      ]
    }
  ],
  "fishing": [
    {
      "name": "CQ9捕鱼",
      "tiers": [
        {
          "tier": "A",
          "turnoverTotal": 50000,
          "ratePercent": 0.9
        },
        {
          "tier": "B",
          "turnoverTotal": 200000,
          "ratePercent": 1.0
        },
        {
          "tier": "C",
          "turnoverTotal": 500000,
          "ratePercent": 1.1
        },
        {
          "tier": "D",
          "turnoverTotal": 1000000,
          "ratePercent": 1.2
        },
        {
          "tier": "E",
          "turnoverTotal": 3000000,
          "ratePercent": 1.3
        },
        {
          "tier": "F",
          "turnoverTotal": 5000000,
          "ratePercent": 1.4
        }
      ]
    },
    {
      "name": "JDB捕鱼",
      "tiers": [
        {
          "tier": "A",
          "turnoverTotal": 50000,
          "ratePercent": 0.9
        },
        {
          "tier": "B",
          "turnoverTotal": 200000,
          "ratePercent": 1.0
        },
        {
          "tier": "C",
          "turnoverTotal": 500000,
          "ratePercent": 1.1
        },
        {
          "tier": "D",
          "turnoverTotal": 1000000,
          "ratePercent": 1.2
        },
        {
          "tier": "E",
          "turnoverTotal": 3000000,
          "ratePercent": 1.3
        },
        {
          "tier": "F",
          "turnoverTotal": 5000000,
          "ratePercent": 1.4
        }
      ]
    }
  ],
  "lottery": [],
  "sports": [
    {
      "name": "Fb体育",
      "tiers": [
        {
          "tier": null,
          "turnoverTotal": null,
          "ratePercent": 0.75
        }
      ]
    },
    {
      "name": "IM体育",
      "tiers": [
        {
          "tier": null,
          "turnoverTotal": null,
          "ratePercent": 0.75
        }
      ]
    },
    {
      "name": "U8体育",
      "tiers": [
        {
          "tier": null,
          "turnoverTotal": null,
          "ratePercent": 0.75
        }
      ]
    },
    {
      "name": "沙巴体育",
      "tiers": [
        {
          "tier": null,
          "turnoverTotal": null,
          "ratePercent": 0.75
        }
      ]
    },
    {
      "name": "皇冠体育",
      "tiers": [
        {
          "tier": null,
          "turnoverTotal": null,
          "ratePercent": 0.75
        }
      ]
    }
  ],
  "esports": []
};
